import script from "./Deposit.vue?vue&type=script&setup=true&lang=js"
export * from "./Deposit.vue?vue&type=script&setup=true&lang=js"

import "./Deposit.vue?vue&type=style&index=0&id=51da910a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51da910a"]])

export default __exports__